var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-none"},[_c('FirstTemplate',{attrs:{"id":"first-template"}}),_c('SecondTemplate',{attrs:{"id":"second-template"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }